import Navbar from '../components/navbar';
import Footer from '../components/footer';
import CardHighlight from '../components/cardHighlight';
import '../App.scss';

import json2019 from '../data/2019-filenames.json';
import json2020 from '../data/2020-filenames.json';
import json2021 from '../data/2021-filenames.json';


import { useState } from 'react';


export default function Search(props) {

	console.log(props);

	var newtitles = new Set();

	var titlesList = json2021["movies"].concat(json2021["tv"])
		.concat(json2020["movies"])
		.concat(json2020["tv"])
		.concat(json2019["movies"])
		.concat(json2019["tv"])
	
	for (let i = 0; i < titlesList.length; i++) {
		let t = titlesList[i]
		if (!newtitles.has(t)) {
			newtitles.add(t);
		}
	}

	var allCardData = []
	newtitles.forEach(function(title) {

		allCardData.push({"title": title})
	})
	// console.log("cardData", cardData);

	// ** search filter tutorial from https://www.geeksforgeeks.org/how-to-implement-search-filter-functionality-in-reactjs/
	// const [cardData, setCardData] = useState(allCardData);
	
	var searchDefault = "";
	if (props.searchVal)
		searchDefault = props.defaultVal;

	const [searchVal, setSearchVal] = useState(searchDefault);

	function searchFilter(cardData) {
		return (cardData.title.toLowerCase().includes(searchVal.toLowerCase()))
	 }


    return (
		<div className="App">
			<header>
				<Navbar></Navbar>
			</header>
		  
			<body>
			
			<div className='white'>
				<div className="align-left section-header flex-col gap-24">
					<h1>Search Reviews</h1>
					{/* <div className='flex-row search'> */}
						<input 					
							className="search-page-input"
							placeholder='Search diversity scores for movies and TV'
							onChange={e => {
								setSearchVal(e.target.value);
							}}
						>
						</input>
					{/* </div> */}
					<p>
						{allCardData.filter((c) => searchFilter(c)).length} results
					</p>
				</div>

			
			
				<div className='align-left collection'>
					{allCardData.filter((c) => searchFilter(c)).map(item => (
					<CardHighlight
						title={item["title"]}
					/>
					))}
				</div>

			</div>

				<Footer/>
			</body>
		</div>
	  );
	}